import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import CloseIcon from "@material-ui/icons/Close";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    fieldRow: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(2),
    },
    deleteButton: {
        padding: 0,
    },
    deleteButtonContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
    },
    emptyStateMessage: {
        textAlign: "center",
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
}));

function RuleDialog({
                        open,
                        handleClose,
                        ruleData,
                        feeId,
                        ruleName,
                        onSubmit,
                        onCleanRule,
                        enableEditing
                    }) {
    const classes = useStyles();
    const [modelAmounts, setModelAmounts] = useState([]);

    useEffect(() => {
        if (ruleData && ruleData.payload) {
            const amounts = Object.entries(ruleData.payload).map(([model, amount]) => ({
                vehicleModel: model,
                amountDecrease: amount
            }));
            setModelAmounts(amounts.length > 0 ? amounts : []);
        } else {
            setModelAmounts([]);
        }
    }, [ruleData]);

    const handleAddField = () => {
        setModelAmounts([...modelAmounts, { vehicleModel: "", amountDecrease: "" }]);
    };

    const handleDeleteField = (index) => {
        const updatedFields = [...modelAmounts];
        updatedFields.splice(index, 1);
        setModelAmounts(updatedFields);
    };

    const handleVehicleModelChange = (index, value) => {
        const updatedFields = [...modelAmounts];
        updatedFields[index].vehicleModel = value;
        setModelAmounts(updatedFields);
    };

    const handleAmountChange = (index, value) => {
        const updatedFields = [...modelAmounts];

        if (value === '') {
            updatedFields[index].amountDecrease = value;
            setModelAmounts(updatedFields);
            return;
        }

        const rawValue = value.startsWith('-') ? value.substring(1) : value;

        const numberValue = parseFloat(rawValue);
        if (!isNaN(numberValue)) {
            updatedFields[index].amountDecrease = `-${rawValue}`;
            setModelAmounts(updatedFields);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {};
        modelAmounts.forEach(({ vehicleModel, amountDecrease }) => {
            if (vehicleModel && amountDecrease !== '') {
                payload[vehicleModel] = parseFloat(amountDecrease);
            }
        });

        const rulePayload = {
            feeId,
            rule: ruleName,
            payload
        };

        onSubmit(rulePayload);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md">
            <DialogTitle id="rule-dialog-title">
                Conquest Discount Rule Modifications
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>

                    {modelAmounts.length === 0 ? (
                        <div className={classes.emptyStateMessage}>
                            <Typography variant="body1">
                                No vehicle models added. Add a vehicle model or submit with an empty payload.
                            </Typography>
                        </div>
                    ) : (
                        <Grid container spacing={2}>
                            {modelAmounts.map((field, index) => (
                                <React.Fragment key={index}>
                                    <Grid item xs={5}>
                                        <TextField
                                            required={true}
                                            type="text"
                                            value={field.vehicleModel}
                                            onChange={(e) => handleVehicleModelChange(index, e.target.value)}
                                            placeholder="Enter Brand"
                                            label="Brand"
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <TextField
                                            required={true}
                                            type="number"
                                            value={field.amountDecrease}
                                            onChange={(e) => handleAmountChange(index, e.target.value)}
                                            placeholder="Enter Additional Discount"
                                            label="Additional Discount"
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <div className={classes.deleteButtonContainer}>
                                            <IconButton
                                                className={classes.deleteButton}
                                                onClick={() => handleDeleteField(index)}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    </Grid>
                                </React.Fragment>
                            ))}
                        </Grid>
                    )}

                    <div style={{ marginTop: "16px", marginBottom: "16px" }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={handleAddField}
                        >
                            Add Vehicle Model
                        </Button>
                    </div>

                    <DialogActions>
                        <Button
                            onClick={handleClose}
                            color="secondary"
                            variant="outlined"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                if (onCleanRule) {
                                    onCleanRule(feeId);
                                    handleClose();
                                } else {
                                    const rulePayload = {
                                        feeId,
                                        rule: "None",
                                        payload: {}
                                    };
                                    onSubmit(rulePayload);
                                }
                            }}
                            color="secondary"
                            variant="outlined"
                            disabled={enableEditing === false}
                        >
                            Clean rule
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={enableEditing === false}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </DialogContent>
            </form>
        </Dialog>
    );
}

export default RuleDialog;
